import MedicalAdapter from './base';

export default class Schedule extends MedicalAdapter {
  modelNamePlural = 'schedules';
}
